import React from "react";
import { Link } from "react-router-dom";

//Import Custom Compoenet
import useViewport from '../useViewport';
import ProductImage from './product-image';

function ProductTypeCatalog(props) {
  const { isImageLoad = true } = props;
  let { addClass = "", product } = props;
  const { width } = useViewport();
  const breakpoint = 992;

  return (
    <div className={`product-default ${addClass}`} style={props.style}>
      <figure>
        {
          isImageLoad ?
            <Link to={`${process.env.PUBLIC_URL}/produkty/${product.category && product.category.category_slug}/${product.variants.length > 0 ? product.variants.find(variant => variant.product_variant_order === 50) ? product.variants.find(variant => variant.product_variant_order === 50).product_variant_slug : product.variants.find(variant => variant.product_variant_active).product_variant_slug : product.product_slug}`}>
              <div className="lazy-overlay bg-3"></div>
              {
                product.images.slice(0, 1).map(image => (
                  <ProductImage
                    key={image.product_image_id}
                    image={image}
                    alt={image.product_image_alt || product.product_name}
                  />
                ))
              }
              {
                width > breakpoint ?
                  product.images.length >= 2 ?
                    product.images.slice(1, 2).map(image => (
                      <ProductImage
                        key={image.product_image_id}
                        image={image}
                        alt={image.product_image_alt || product.product_name}
                        wrapperClassName="product-image-hover"
                      />
                    ))
                    : null
                  : null
              }
            </Link>
            : null
        }
      </figure>

      <div className="product-details">
        <h3 className="product-title" style={{ fontWeight: '600' }}>
          <Link to={`${process.env.PUBLIC_URL}/produkty/${product.category && product.category.category_slug}/${product.variants.length > 0 ? product.variants.find(variant => variant.product_variant_order === 50) ? product.variants.find(variant => variant.product_variant_order === 50).product_variant_slug : product.variants.find(variant => variant.product_variant_active).product_variant_slug : product.product_slug}`}>{product.product_name}</Link>
        </h3>
        <div className="category-wrap">
          <div className="category-list">
            <Link to={`${process.env.PUBLIC_URL}/produkty/${product.category && product.category.category_slug}`} className="product-category">{product.category && product.category.category_name}</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(ProductTypeCatalog);
